// GENERATED by bin/tokens build from design/tokens.json — do not edit.
// tokens 2026-09-16

/** Every shipped token's terminal value, by path: tokens.color.print[700] === "#346aad". */
export const tokens = {
  color: {
    transparent: "rgb(0 0 0 / 0)",
    stone: {
      "50": "#fcf9f7",
      "100": "#f8f0ea",
      "200": "#f3e7dd",
      "300": "#e4d4c8",
      "400": "#cabbaf",
      "500": "#b0a196",
      "600": "#918378",
      "700": "#74665c",
      "800": "#574a40",
      "900": "#3f3329",
      "950": "#2d2218",
    },
    ink: {
      "950": "#1e252e",
      emphasis: "rgb(30 37 46 / 0.78)",
      body: "rgb(30 37 46 / 0.72)",
      quiet: "rgb(30 37 46 / 0.65)",
      nontext: "rgb(30 37 46 / 0.52)",
      hairline: "rgb(30 37 46 / 0.16)",
      rule: "rgb(30 37 46 / 0.09)",
    },
    ledger: {
      caption: "#123560",
      header: "#f8f0ea",
      label: "#574a40",
      "header-rule": "#e4d4c8",
      rule: "rgb(30 37 46 / 0.07)",
      hover: "rgb(248 240 234 / 0.5)",
      selected: "rgb(248 240 234 / 0.5)",
      "selected-hover": "rgb(248 240 234 / 0.5)",
    },
    print: {
      "300": "#c1dafa",
      "400": "#a1c1ea",
      "500": "#7fa7db",
      "600": "#5988c4",
      "700": "#346aad",
      "800": "#1d4d87",
      "900": "#123560",
      "950": "#0d2541",
    },
    onprint: {
      emphasis: "rgb(252 249 247 / 0.78)",
      body: "rgb(252 249 247 / 0.72)",
      quiet: "rgb(252 249 247 / 0.65)",
      nontext: "rgb(252 249 247 / 0.52)",
      rule: "rgb(252 249 247 / 0.17)",
      hover: "rgb(252 249 247 / 0.07)",
      edge: "rgb(252 249 247 / 0.28)",
    },
    know: {
      "50": "#f1fdfe",
      "100": "#e0f7fa",
      "500": "#09bac9",
      "800": "#005a64",
    },
    believe: {
      "50": "#faf8ff",
      "100": "#f2eeff",
      "500": "#ac8dff",
      "800": "#523c87",
    },
    say: {
      "50": "#fff7f0",
      "100": "#ffebde",
      "200": "#ffddc6",
      "500": "#fd7832",
      "800": "#832e00",
    },
    do: {
      "50": "#f2fef4",
      "100": "#e1f9e6",
      "500": "#2fc96b",
      "800": "#006023",
    },
    caution: {
      "50": "#fff9f0",
      "500": "#d59725",
      "700": "#905d00",
    },
    lamp: "#fff6e2",
    white: "#fcf9f7",
    black: "#1e252e",
    "alpha-white": "#fcf9f7",
    "alpha-black": "#1e252e",
    gray: {
      "25": "#fcf9f7",
      "50": "#f8f0ea",
      "100": "#f3e7dd",
      "200": "#e4d4c8",
      "300": "#cabbaf",
      "400": "rgb(30 37 46 / 0.52)",
      "500": "rgb(30 37 46 / 0.65)",
      "600": "rgb(30 37 46 / 0.72)",
      "700": "rgb(30 37 46 / 0.78)",
      "800": "#1e252e",
      "900": "#1e252e",
      "950": "#0d2541",
    },
    brand: {
      "25": "#fcf9f7",
      "50": "#f8f0ea",
      "100": "#f3e7dd",
      "200": "#e4d4c8",
      "300": "#cabbaf",
      "400": "rgb(30 37 46 / 0.52)",
      "500": "rgb(30 37 46 / 0.65)",
      "600": "#1e252e",
      "700": "#1e252e",
      "800": "#0d2541",
      "900": "#0d2541",
      "950": "#0d2541",
    },
    error: {
      "25": "#fff9f0",
      "50": "#fff9f0",
      "100": "#fff9f0",
      "200": "#d59725",
      "300": "#d59725",
      "400": "#d59725",
      "500": "#d59725",
      "600": "#905d00",
      "700": "#905d00",
      "800": "#905d00",
      "900": "#905d00",
      "950": "#905d00",
    },
    warning: {
      "25": "#fff9f0",
      "50": "#fff9f0",
      "100": "#fff9f0",
      "200": "#d59725",
      "300": "#d59725",
      "400": "#d59725",
      "500": "#d59725",
      "600": "#905d00",
      "700": "#905d00",
      "800": "#905d00",
      "900": "#905d00",
      "950": "#905d00",
    },
    success: {
      "25": "#f2fef4",
      "50": "#f2fef4",
      "100": "#e1f9e6",
      "200": "#e1f9e6",
      "300": "#2fc96b",
      "400": "#2fc96b",
      "500": "#2fc96b",
      "600": "#006023",
      "700": "#006023",
      "800": "#006023",
      "900": "#006023",
      "950": "#006023",
    },
    utility: {
      gray: {
        "50": "#f3e7dd",
        "100": "#e4d4c8",
        "200": "rgb(30 37 46 / 0.16)",
        "300": "#cabbaf",
        "400": "rgb(30 37 46 / 0.52)",
        "500": "rgb(30 37 46 / 0.65)",
        "600": "rgb(30 37 46 / 0.72)",
        "700": "rgb(30 37 46 / 0.78)",
        "800": "#1e252e",
        "900": "#1e252e",
      },
      brand: {
        "50": "#fcf9f7",
        "100": "#f3e7dd",
        "200": "#346aad",
        "300": "#7fa7db",
        "400": "#5988c4",
        "500": "#5988c4",
        "600": "#346aad",
        "700": "#346aad",
        "800": "#1d4d87",
        "900": "#123560",
        "50_alt": "#fcf9f7",
        "100_alt": "#f3e7dd",
        "200_alt": "#346aad",
        "300_alt": "#7fa7db",
        "400_alt": "#5988c4",
        "500_alt": "#5988c4",
        "600_alt": "#346aad",
        "700_alt": "#346aad",
        "800_alt": "#1d4d87",
        "900_alt": "#123560",
      },
      error: {
        "50": "#fff9f0",
        "100": "#fff9f0",
        "200": "#d59725",
        "300": "#d59725",
        "400": "#d59725",
        "500": "#d59725",
        "600": "#905d00",
        "700": "#905d00",
      },
      warning: {
        "50": "#fff9f0",
        "100": "#fff9f0",
        "200": "#d59725",
        "300": "#d59725",
        "400": "#d59725",
        "500": "#d59725",
        "600": "#905d00",
        "700": "#905d00",
      },
      yellow: {
        "50": "#fff9f0",
        "100": "#fff9f0",
        "200": "#d59725",
        "300": "#d59725",
        "400": "#d59725",
        "500": "#d59725",
        "600": "#905d00",
        "700": "#905d00",
      },
      success: {
        "50": "#f2fef4",
        "100": "#e1f9e6",
        "200": "#e1f9e6",
        "300": "#2fc96b",
        "400": "#2fc96b",
        "500": "#2fc96b",
        "600": "#006023",
        "700": "#006023",
      },
      green: {
        "50": "#f2fef4",
        "100": "#e1f9e6",
        "200": "#e1f9e6",
        "300": "#2fc96b",
        "400": "#2fc96b",
        "500": "#2fc96b",
        "600": "#006023",
        "700": "#006023",
      },
      blue: {
        "50": "#fcf9f7",
        "100": "#f3e7dd",
        "200": "#7fa7db",
        "300": "#7fa7db",
        "400": "#5988c4",
        "500": "#5988c4",
        "600": "#346aad",
        "700": "#1d4d87",
      },
      "blue-light": {
        "50": "#fcf9f7",
        "100": "#f3e7dd",
        "200": "#7fa7db",
        "300": "#7fa7db",
        "400": "#5988c4",
        "500": "#5988c4",
        "600": "#346aad",
        "700": "#1d4d87",
      },
      "blue-dark": {
        "50": "#fcf9f7",
        "100": "#f3e7dd",
        "200": "#5988c4",
        "300": "#5988c4",
        "400": "#346aad",
        "500": "#346aad",
        "600": "#1d4d87",
        "700": "#123560",
      },
      "gray-blue": {
        "50": "#fcf9f7",
        "100": "#f3e7dd",
        "200": "#7fa7db",
        "300": "#7fa7db",
        "400": "#5988c4",
        "500": "#5988c4",
        "600": "#346aad",
        "700": "#1d4d87",
      },
      indigo: {
        "50": "#fcf9f7",
        "100": "#f3e7dd",
        "200": "#5988c4",
        "300": "#5988c4",
        "400": "#346aad",
        "500": "#346aad",
        "600": "#1d4d87",
        "700": "#123560",
      },
      purple: {
        "50": "#faf8ff",
        "100": "#f2eeff",
        "200": "#ac8dff",
        "300": "#ac8dff",
        "400": "#ac8dff",
        "500": "#ac8dff",
        "600": "#523c87",
        "700": "#523c87",
      },
      pink: {
        "50": "#faf8ff",
        "100": "#f2eeff",
        "200": "#ac8dff",
        "300": "#ac8dff",
        "400": "#ac8dff",
        "500": "#ac8dff",
        "600": "#523c87",
        "700": "#523c87",
      },
      fuchsia: {
        "50": "#faf8ff",
        "100": "#f2eeff",
        "200": "#ac8dff",
        "300": "#ac8dff",
        "400": "#ac8dff",
        "500": "#ac8dff",
        "600": "#523c87",
        "700": "#523c87",
      },
      orange: {
        "50": "#fff7f0",
        "100": "#ffebde",
        "200": "#fd7832",
        "300": "#fd7832",
        "400": "#fd7832",
        "500": "#fd7832",
        "600": "#832e00",
        "700": "#832e00",
      },
      "orange-dark": {
        "50": "#fff7f0",
        "100": "#ffebde",
        "200": "#fd7832",
        "300": "#fd7832",
        "400": "#fd7832",
        "500": "#fd7832",
        "600": "#832e00",
        "700": "#832e00",
      },
      know: {
        "50": "#f1fdfe",
        "100": "#e0f7fa",
        "200": "#09bac9",
        "300": "#09bac9",
        "400": "#09bac9",
        "500": "#09bac9",
        "600": "#005a64",
        "700": "#005a64",
      },
    },
    text: {
      white: "#fcf9f7",
      primary: "#1e252e",
      secondary: "rgb(30 37 46 / 0.78)",
      secondary_hover: "#1e252e",
      tertiary: "rgb(30 37 46 / 0.72)",
      tertiary_hover: "rgb(30 37 46 / 0.78)",
      quaternary: "rgb(30 37 46 / 0.65)",
      disabled: "rgb(30 37 46 / 0.65)",
      placeholder: "rgb(30 37 46 / 0.65)",
      placeholder_subtle: "rgb(30 37 46 / 0.52)",
      "error-primary": "#905d00",
      "error-primary_hover": "#905d00",
      "warning-primary": "#905d00",
      "success-primary": "#006023",
      "editor-icon-fg": "rgb(30 37 46 / 0.52)",
      "editor-icon-fg_active": "rgb(30 37 46 / 0.65)",
      "primary_on-brand": "#fcf9f7",
      "secondary_on-brand": "rgb(252 249 247 / 0.78)",
      "tertiary_on-brand": "rgb(252 249 247 / 0.72)",
      "quaternary_on-brand": "rgb(252 249 247 / 0.65)",
      "brand-primary": "#1e252e",
      "brand-secondary": "#346aad",
      "brand-secondary_hover": "#1d4d87",
      "brand-tertiary": "#346aad",
      "brand-tertiary_alt": "#346aad",
    },
    border: {
      provisional: "rgb(176 161 150 / 0.5)",
      primary: "#cabbaf",
      secondary: "rgb(30 37 46 / 0.16)",
      secondary_alt: "rgb(30 37 46 / 0.16)",
      tertiary: "rgb(30 37 46 / 0.09)",
      error: "#d59725",
      error_subtle: "#d59725",
      disabled: "#e4d4c8",
      disabled_subtle: "#f3e7dd",
      brand: "#5988c4",
      brand_alt: "#346aad",
      "lit-edge": "rgb(45 34 24 / 0.3)",
    },
    fg: {
      white: "#fcf9f7",
      primary: "#1e252e",
      secondary: "rgb(30 37 46 / 0.78)",
      secondary_hover: "#1e252e",
      tertiary: "rgb(30 37 46 / 0.72)",
      tertiary_hover: "rgb(30 37 46 / 0.78)",
      quaternary: "rgb(30 37 46 / 0.52)",
      quaternary_hover: "rgb(30 37 46 / 0.65)",
      disabled: "rgb(30 37 46 / 0.52)",
      disabled_subtle: "#cabbaf",
      "warning-primary": "#905d00",
      "warning-secondary": "#d59725",
      "success-primary": "#006023",
      "success-secondary": "#2fc96b",
      "error-primary": "#905d00",
      "error-secondary": "#d59725",
      "brand-primary": "#1e252e",
      "brand-primary_alt": "#1e252e",
      "brand-secondary": "#5988c4",
      "brand-secondary_alt": "#5988c4",
      "brand-secondary_hover": "#346aad",
    },
    bg: {
      primary: "#fcf9f7",
      primary_alt: "#fcf9f7",
      primary_hover: "#f8f0ea",
      "primary-solid": "#123560",
      secondary: "#f3e7dd",
      secondary_alt: "#f3e7dd",
      secondary_hover: "#e4d4c8",
      secondary_subtle: "#f8f0ea",
      "secondary-solid": "#1d4d87",
      tertiary: "#e4d4c8",
      quaternary: "#cabbaf",
      active: "rgb(248 240 234 / 0.5)",
      disabled: "#f3e7dd",
      disabled_subtle: "#f8f0ea",
      overlay: "#0d2541",
      "error-primary": "#fff9f0",
      "error-secondary": "#fff9f0",
      "error-solid": "#905d00",
      "error-solid_hover": "#905d00",
      "warning-primary": "#fff9f0",
      "warning-secondary": "#fff9f0",
      "warning-solid": "#d59725",
      "success-primary": "#f2fef4",
      "success-secondary": "#e1f9e6",
      "success-solid": "#2fc96b",
      "brand-primary": "#f3e7dd",
      "brand-primary_alt": "#e4d4c8",
      "brand-secondary": "#e4d4c8",
      "brand-solid": "#1d4d87",
      "brand-solid_hover": "#123560",
      "brand-section": "#123560",
      "brand-section_subtle": "#1d4d87",
    },
    "app-store-badge": {
      border: "#cabbaf",
    },
    avatar: {
      bg: "#f3e7dd",
      "contrast-border": "rgb(30 37 46 / 0.16)",
      "profile-photo-border": "#fcf9f7",
      "styles-bg-neutral": "#e4d4c8",
    },
    button: {
      "primary-icon": "rgb(252 249 247 / 0.72)",
      "primary-icon_hover": "#fcf9f7",
      "destructive-primary-icon": "rgb(252 249 247 / 0.72)",
      "destructive-primary-icon_hover": "#fcf9f7",
    },
    "featured-icon": {
      "light-fg-brand": "#1e252e",
      "light-fg-gray": "rgb(30 37 46 / 0.65)",
      "light-fg-error": "#905d00",
      "light-fg-warning": "#905d00",
      "light-fg-success": "#006023",
    },
    "focus-ring": "#5988c4",
    "focus-ring-error": "#d59725",
    "footer-button": {
      fg: "rgb(252 249 247 / 0.72)",
      fg_hover: "#fcf9f7",
    },
    icon: {
      "fg-brand": "#346aad",
      "fg-brand_on-brand": "rgb(252 249 247 / 0.78)",
    },
    "screen-mockup": {
      border: "#123560",
    },
    "slider-handle": {
      bg: "#fcf9f7",
      border: "#1e252e",
    },
    toggle: {
      border: "#cabbaf",
      "button-fg_disabled": "#f8f0ea",
      "slim-border_pressed": "#1e252e",
      "slim-border_pressed-hover": "#0d2541",
    },
    tooltip: {
      "supporting-text": "rgb(252 249 247 / 0.72)",
    },
    scrim: {
      centre: "rgb(13 37 65 / 0.55)",
      edge: "rgb(13 37 65 / 0.8)",
    },
    board: {
      top: "#133a69",
      bottom: "#0c305a",
      lamp: "rgb(255 246 226 / 0.13)",
    },
    map: {
      ground: "#f3e7dd",
      water: "#c1dafa",
      "road-core": "#fcf9f7",
      "road-major": "#ffddc6",
      rail: "#b0a196",
      transit: "#cabbaf",
      landcover: "#c8eecc",
      wood: "#9fdfab",
      pin: "#2fc96b",
      "pin-halo": "rgb(47 201 107 / 0.16)",
      office: "#123560",
      "office-halo": "rgb(18 53 96 / 0.14)",
      route: "#346aad",
      chip: "rgb(252 249 247 / 0.94)",
    },
  },
  font: {
    body: "\"IBM Plex Sans\", -apple-system, \"Segoe UI\", Roboto, Arial, sans-serif",
    display: "\"IBM Plex Sans Condensed\", \"IBM Plex Sans\", -apple-system, \"Segoe UI\", Roboto, Arial, sans-serif",
    condensed: "\"IBM Plex Sans Condensed\", \"IBM Plex Sans\", -apple-system, \"Segoe UI\", Roboto, Arial, sans-serif",
    mono: "\"IBM Plex Mono\", ui-monospace, SFMono-Regular, Menlo, Consolas, \"Liberation Mono\", monospace",
  },
  radius: {
    none: "0px",
    xs: "2px",
    sm: "3px",
    DEFAULT: "4px",
    md: "4px",
    lg: "5px",
    xl: "7px",
    "2xl": "10px",
    "3xl": "14px",
    full: "9999px",
  },
  shadow: {
    xs: "0 0 #0000",
    sm: "0 1px 2px rgba(45, 34, 24, 0.1), 0 4px 10px rgba(45, 34, 24, 0.14)",
    md: "0 1px 2px rgba(45, 34, 24, 0.1), 0 6px 18px rgba(45, 34, 24, 0.12)",
    lg: "0 1px 2px rgba(45, 34, 24, 0.1), 0 6px 18px rgba(45, 34, 24, 0.12)",
    xl: "0 1px 2px rgba(45, 34, 24, 0.1), 0 10px 26px rgba(45, 34, 24, 0.16)",
    "2xl": "0 1px 2px rgba(45, 34, 24, 0.08), 0 18px 40px -26px rgba(45, 34, 24, 0.3)",
    "3xl": "0 1px 2px rgba(45, 34, 24, 0.08), 0 22px 48px -26px rgba(45, 34, 24, 0.3)",
    skeumorphic: "0 0 #0000",
    "xs-skeumorphic": "0 0 #0000",
    lift: "0 1px 2px rgba(45, 34, 24, 0.1), 0 6px 18px rgba(45, 34, 24, 0.12)",
    "paper-highlight": "inset 1px 1px 0 rgb(255 246 226 / 0.55)",
  },
  ease: {
    snap: "cubic-bezier(0.2, 0.9, 0.24, 1)",
    settle: "cubic-bezier(0.22, 1, 0.36, 1)",
  },
  duration: {
    instant: "100ms",
    snap: "160ms",
    settle: "220ms",
  },
  breakpoint: {
    xxs: "320px",
    xs: "600px",
  },
  "max-width": {
    container: "1280px",
  },
  text: {
    "3xs": {"fontSize":"9px"},
    "2xs": {"fontSize":"10px"},
    xs: {"fontSize":"11px","lineHeight":"16px"},
    sm: {"fontSize":"13px","lineHeight":"20px"},
    md: {"fontSize":"14px","lineHeight":"22px"},
    lg: {"fontSize":"16px","lineHeight":"24px"},
    xl: {"fontSize":"18px","lineHeight":"28px"},
    "display-xs": {"fontSize":"22px","lineHeight":"26px","letterSpacing":"-0.008em"},
    "display-sm": {"fontSize":"26px","lineHeight":"30px","letterSpacing":"-0.012em"},
    "display-md": {"fontSize":"32px","lineHeight":"35px","letterSpacing":"-0.014em"},
    "display-lg": {"fontSize":"40px","lineHeight":"42px","letterSpacing":"-0.018em"},
    "display-xl": {"fontSize":"58px","lineHeight":"60px","letterSpacing":"-0.015em"},
    "display-2xl": {"fontSize":"72px","lineHeight":"74px","letterSpacing":"-0.018em"},
  },
  tracking: {
    eyebrow: "0.16em",
    label: "0.1em",
    chip: "0.04em",
  },
  spacing: {
    "ledger-header": "34px",
    "ledger-actions": "46px",
    "ground-band": "150px",
    "ground-handle": "58px",
  },
  border: {
    "rule-width": "3px",
  },
  email: {
    masthead: "#123560",
    "masthead-text": "#fcf9f7",
    wrapper: "#f8f0ea",
    card: "#fcf9f7",
    text: "#1e252e",
    link: "#346aad",
    button: "#1e252e",
    "button-text": "#fcf9f7",
    footer: "#6a6c70",
    font: {
      sans: "Helvetica, Arial, sans-serif",
      mono: "Menlo, Consolas, \"Courier New\", monospace",
    },
  },
} as const

/** The paths in tokens.json, for the readers that need the variable rather than the value. */
export type TokenPath =
  | "color.transparent"
  | "color.stone.50"
  | "color.stone.100"
  | "color.stone.200"
  | "color.stone.300"
  | "color.stone.400"
  | "color.stone.500"
  | "color.stone.600"
  | "color.stone.700"
  | "color.stone.800"
  | "color.stone.900"
  | "color.stone.950"
  | "color.ink.950"
  | "color.ink.emphasis"
  | "color.ink.body"
  | "color.ink.quiet"
  | "color.ink.nontext"
  | "color.ink.hairline"
  | "color.ink.rule"
  | "color.ledger.caption"
  | "color.ledger.header"
  | "color.ledger.label"
  | "color.ledger.header-rule"
  | "color.ledger.rule"
  | "color.ledger.hover"
  | "color.ledger.selected"
  | "color.ledger.selected-hover"
  | "color.print.300"
  | "color.print.400"
  | "color.print.500"
  | "color.print.600"
  | "color.print.700"
  | "color.print.800"
  | "color.print.900"
  | "color.print.950"
  | "color.onprint.emphasis"
  | "color.onprint.body"
  | "color.onprint.quiet"
  | "color.onprint.nontext"
  | "color.onprint.rule"
  | "color.onprint.hover"
  | "color.onprint.edge"
  | "color.know.50"
  | "color.know.100"
  | "color.know.500"
  | "color.know.800"
  | "color.believe.50"
  | "color.believe.100"
  | "color.believe.500"
  | "color.believe.800"
  | "color.say.50"
  | "color.say.100"
  | "color.say.200"
  | "color.say.500"
  | "color.say.800"
  | "color.do.50"
  | "color.do.100"
  | "color.do.500"
  | "color.do.800"
  | "color.caution.50"
  | "color.caution.500"
  | "color.caution.700"
  | "color.lamp"
  | "color.white"
  | "color.black"
  | "color.alpha-white"
  | "color.alpha-black"
  | "color.gray.25"
  | "color.gray.50"
  | "color.gray.100"
  | "color.gray.200"
  | "color.gray.300"
  | "color.gray.400"
  | "color.gray.500"
  | "color.gray.600"
  | "color.gray.700"
  | "color.gray.800"
  | "color.gray.900"
  | "color.gray.950"
  | "color.brand.25"
  | "color.brand.50"
  | "color.brand.100"
  | "color.brand.200"
  | "color.brand.300"
  | "color.brand.400"
  | "color.brand.500"
  | "color.brand.600"
  | "color.brand.700"
  | "color.brand.800"
  | "color.brand.900"
  | "color.brand.950"
  | "color.error.25"
  | "color.error.50"
  | "color.error.100"
  | "color.error.200"
  | "color.error.300"
  | "color.error.400"
  | "color.error.500"
  | "color.error.600"
  | "color.error.700"
  | "color.error.800"
  | "color.error.900"
  | "color.error.950"
  | "color.warning.25"
  | "color.warning.50"
  | "color.warning.100"
  | "color.warning.200"
  | "color.warning.300"
  | "color.warning.400"
  | "color.warning.500"
  | "color.warning.600"
  | "color.warning.700"
  | "color.warning.800"
  | "color.warning.900"
  | "color.warning.950"
  | "color.success.25"
  | "color.success.50"
  | "color.success.100"
  | "color.success.200"
  | "color.success.300"
  | "color.success.400"
  | "color.success.500"
  | "color.success.600"
  | "color.success.700"
  | "color.success.800"
  | "color.success.900"
  | "color.success.950"
  | "color.utility.gray.50"
  | "color.utility.gray.100"
  | "color.utility.gray.200"
  | "color.utility.gray.300"
  | "color.utility.gray.400"
  | "color.utility.gray.500"
  | "color.utility.gray.600"
  | "color.utility.gray.700"
  | "color.utility.gray.800"
  | "color.utility.gray.900"
  | "color.utility.brand.50"
  | "color.utility.brand.100"
  | "color.utility.brand.200"
  | "color.utility.brand.300"
  | "color.utility.brand.400"
  | "color.utility.brand.500"
  | "color.utility.brand.600"
  | "color.utility.brand.700"
  | "color.utility.brand.800"
  | "color.utility.brand.900"
  | "color.utility.brand.50_alt"
  | "color.utility.brand.100_alt"
  | "color.utility.brand.200_alt"
  | "color.utility.brand.300_alt"
  | "color.utility.brand.400_alt"
  | "color.utility.brand.500_alt"
  | "color.utility.brand.600_alt"
  | "color.utility.brand.700_alt"
  | "color.utility.brand.800_alt"
  | "color.utility.brand.900_alt"
  | "color.utility.error.50"
  | "color.utility.error.100"
  | "color.utility.error.200"
  | "color.utility.error.300"
  | "color.utility.error.400"
  | "color.utility.error.500"
  | "color.utility.error.600"
  | "color.utility.error.700"
  | "color.utility.warning.50"
  | "color.utility.warning.100"
  | "color.utility.warning.200"
  | "color.utility.warning.300"
  | "color.utility.warning.400"
  | "color.utility.warning.500"
  | "color.utility.warning.600"
  | "color.utility.warning.700"
  | "color.utility.yellow.50"
  | "color.utility.yellow.100"
  | "color.utility.yellow.200"
  | "color.utility.yellow.300"
  | "color.utility.yellow.400"
  | "color.utility.yellow.500"
  | "color.utility.yellow.600"
  | "color.utility.yellow.700"
  | "color.utility.success.50"
  | "color.utility.success.100"
  | "color.utility.success.200"
  | "color.utility.success.300"
  | "color.utility.success.400"
  | "color.utility.success.500"
  | "color.utility.success.600"
  | "color.utility.success.700"
  | "color.utility.green.50"
  | "color.utility.green.100"
  | "color.utility.green.200"
  | "color.utility.green.300"
  | "color.utility.green.400"
  | "color.utility.green.500"
  | "color.utility.green.600"
  | "color.utility.green.700"
  | "color.utility.blue.50"
  | "color.utility.blue.100"
  | "color.utility.blue.200"
  | "color.utility.blue.300"
  | "color.utility.blue.400"
  | "color.utility.blue.500"
  | "color.utility.blue.600"
  | "color.utility.blue.700"
  | "color.utility.blue-light.50"
  | "color.utility.blue-light.100"
  | "color.utility.blue-light.200"
  | "color.utility.blue-light.300"
  | "color.utility.blue-light.400"
  | "color.utility.blue-light.500"
  | "color.utility.blue-light.600"
  | "color.utility.blue-light.700"
  | "color.utility.blue-dark.50"
  | "color.utility.blue-dark.100"
  | "color.utility.blue-dark.200"
  | "color.utility.blue-dark.300"
  | "color.utility.blue-dark.400"
  | "color.utility.blue-dark.500"
  | "color.utility.blue-dark.600"
  | "color.utility.blue-dark.700"
  | "color.utility.gray-blue.50"
  | "color.utility.gray-blue.100"
  | "color.utility.gray-blue.200"
  | "color.utility.gray-blue.300"
  | "color.utility.gray-blue.400"
  | "color.utility.gray-blue.500"
  | "color.utility.gray-blue.600"
  | "color.utility.gray-blue.700"
  | "color.utility.indigo.50"
  | "color.utility.indigo.100"
  | "color.utility.indigo.200"
  | "color.utility.indigo.300"
  | "color.utility.indigo.400"
  | "color.utility.indigo.500"
  | "color.utility.indigo.600"
  | "color.utility.indigo.700"
  | "color.utility.purple.50"
  | "color.utility.purple.100"
  | "color.utility.purple.200"
  | "color.utility.purple.300"
  | "color.utility.purple.400"
  | "color.utility.purple.500"
  | "color.utility.purple.600"
  | "color.utility.purple.700"
  | "color.utility.pink.50"
  | "color.utility.pink.100"
  | "color.utility.pink.200"
  | "color.utility.pink.300"
  | "color.utility.pink.400"
  | "color.utility.pink.500"
  | "color.utility.pink.600"
  | "color.utility.pink.700"
  | "color.utility.fuchsia.50"
  | "color.utility.fuchsia.100"
  | "color.utility.fuchsia.200"
  | "color.utility.fuchsia.300"
  | "color.utility.fuchsia.400"
  | "color.utility.fuchsia.500"
  | "color.utility.fuchsia.600"
  | "color.utility.fuchsia.700"
  | "color.utility.orange.50"
  | "color.utility.orange.100"
  | "color.utility.orange.200"
  | "color.utility.orange.300"
  | "color.utility.orange.400"
  | "color.utility.orange.500"
  | "color.utility.orange.600"
  | "color.utility.orange.700"
  | "color.utility.orange-dark.50"
  | "color.utility.orange-dark.100"
  | "color.utility.orange-dark.200"
  | "color.utility.orange-dark.300"
  | "color.utility.orange-dark.400"
  | "color.utility.orange-dark.500"
  | "color.utility.orange-dark.600"
  | "color.utility.orange-dark.700"
  | "color.utility.know.50"
  | "color.utility.know.100"
  | "color.utility.know.200"
  | "color.utility.know.300"
  | "color.utility.know.400"
  | "color.utility.know.500"
  | "color.utility.know.600"
  | "color.utility.know.700"
  | "color.text.white"
  | "color.text.primary"
  | "color.text.secondary"
  | "color.text.secondary_hover"
  | "color.text.tertiary"
  | "color.text.tertiary_hover"
  | "color.text.quaternary"
  | "color.text.disabled"
  | "color.text.placeholder"
  | "color.text.placeholder_subtle"
  | "color.text.error-primary"
  | "color.text.error-primary_hover"
  | "color.text.warning-primary"
  | "color.text.success-primary"
  | "color.text.editor-icon-fg"
  | "color.text.editor-icon-fg_active"
  | "color.text.primary_on-brand"
  | "color.text.secondary_on-brand"
  | "color.text.tertiary_on-brand"
  | "color.text.quaternary_on-brand"
  | "color.text.brand-primary"
  | "color.text.brand-secondary"
  | "color.text.brand-secondary_hover"
  | "color.text.brand-tertiary"
  | "color.text.brand-tertiary_alt"
  | "color.border.provisional"
  | "color.border.primary"
  | "color.border.secondary"
  | "color.border.secondary_alt"
  | "color.border.tertiary"
  | "color.border.error"
  | "color.border.error_subtle"
  | "color.border.disabled"
  | "color.border.disabled_subtle"
  | "color.border.brand"
  | "color.border.brand_alt"
  | "color.border.lit-edge"
  | "color.fg.white"
  | "color.fg.primary"
  | "color.fg.secondary"
  | "color.fg.secondary_hover"
  | "color.fg.tertiary"
  | "color.fg.tertiary_hover"
  | "color.fg.quaternary"
  | "color.fg.quaternary_hover"
  | "color.fg.disabled"
  | "color.fg.disabled_subtle"
  | "color.fg.warning-primary"
  | "color.fg.warning-secondary"
  | "color.fg.success-primary"
  | "color.fg.success-secondary"
  | "color.fg.error-primary"
  | "color.fg.error-secondary"
  | "color.fg.brand-primary"
  | "color.fg.brand-primary_alt"
  | "color.fg.brand-secondary"
  | "color.fg.brand-secondary_alt"
  | "color.fg.brand-secondary_hover"
  | "color.bg.primary"
  | "color.bg.primary_alt"
  | "color.bg.primary_hover"
  | "color.bg.primary-solid"
  | "color.bg.secondary"
  | "color.bg.secondary_alt"
  | "color.bg.secondary_hover"
  | "color.bg.secondary_subtle"
  | "color.bg.secondary-solid"
  | "color.bg.tertiary"
  | "color.bg.quaternary"
  | "color.bg.active"
  | "color.bg.disabled"
  | "color.bg.disabled_subtle"
  | "color.bg.overlay"
  | "color.bg.error-primary"
  | "color.bg.error-secondary"
  | "color.bg.error-solid"
  | "color.bg.error-solid_hover"
  | "color.bg.warning-primary"
  | "color.bg.warning-secondary"
  | "color.bg.warning-solid"
  | "color.bg.success-primary"
  | "color.bg.success-secondary"
  | "color.bg.success-solid"
  | "color.bg.brand-primary"
  | "color.bg.brand-primary_alt"
  | "color.bg.brand-secondary"
  | "color.bg.brand-solid"
  | "color.bg.brand-solid_hover"
  | "color.bg.brand-section"
  | "color.bg.brand-section_subtle"
  | "color.app-store-badge.border"
  | "color.avatar.bg"
  | "color.avatar.contrast-border"
  | "color.avatar.profile-photo-border"
  | "color.avatar.styles-bg-neutral"
  | "color.button.primary-icon"
  | "color.button.primary-icon_hover"
  | "color.button.destructive-primary-icon"
  | "color.button.destructive-primary-icon_hover"
  | "color.featured-icon.light-fg-brand"
  | "color.featured-icon.light-fg-gray"
  | "color.featured-icon.light-fg-error"
  | "color.featured-icon.light-fg-warning"
  | "color.featured-icon.light-fg-success"
  | "color.focus-ring"
  | "color.focus-ring-error"
  | "color.footer-button.fg"
  | "color.footer-button.fg_hover"
  | "color.icon.fg-brand"
  | "color.icon.fg-brand_on-brand"
  | "color.screen-mockup.border"
  | "color.slider-handle.bg"
  | "color.slider-handle.border"
  | "color.toggle.border"
  | "color.toggle.button-fg_disabled"
  | "color.toggle.slim-border_pressed"
  | "color.toggle.slim-border_pressed-hover"
  | "color.tooltip.supporting-text"
  | "color.scrim.centre"
  | "color.scrim.edge"
  | "color.board.top"
  | "color.board.bottom"
  | "color.board.lamp"
  | "color.map.ground"
  | "color.map.water"
  | "color.map.road-core"
  | "color.map.road-major"
  | "color.map.rail"
  | "color.map.transit"
  | "color.map.landcover"
  | "color.map.wood"
  | "color.map.pin"
  | "color.map.pin-halo"
  | "color.map.office"
  | "color.map.office-halo"
  | "color.map.route"
  | "color.map.chip"
  | "font.body"
  | "font.display"
  | "font.condensed"
  | "font.mono"
  | "radius.none"
  | "radius.xs"
  | "radius.sm"
  | "radius.DEFAULT"
  | "radius.md"
  | "radius.lg"
  | "radius.xl"
  | "radius.2xl"
  | "radius.3xl"
  | "radius.full"
  | "shadow.xs"
  | "shadow.sm"
  | "shadow.md"
  | "shadow.lg"
  | "shadow.xl"
  | "shadow.2xl"
  | "shadow.3xl"
  | "shadow.skeumorphic"
  | "shadow.xs-skeumorphic"
  | "shadow.lift"
  | "shadow.paper-highlight"
  | "ease.snap"
  | "ease.settle"
  | "duration.instant"
  | "duration.snap"
  | "duration.settle"
  | "breakpoint.xxs"
  | "breakpoint.xs"
  | "max-width.container"
  | "text.3xs"
  | "text.2xs"
  | "text.xs"
  | "text.sm"
  | "text.md"
  | "text.lg"
  | "text.xl"
  | "text.display-xs"
  | "text.display-sm"
  | "text.display-md"
  | "text.display-lg"
  | "text.display-xl"
  | "text.display-2xl"
  | "tracking.eyebrow"
  | "tracking.label"
  | "tracking.chip"
  | "spacing.ledger-header"
  | "spacing.ledger-actions"
  | "spacing.ground-band"
  | "spacing.ground-handle"
  | "border.rule-width"
  | "email.masthead"
  | "email.masthead-text"
  | "email.wrapper"
  | "email.card"
  | "email.text"
  | "email.link"
  | "email.button"
  | "email.button-text"
  | "email.footer"
  | "email.font.sans"
  | "email.font.mono"

/** The CSS variable behind a token path: cssVar("color.bg.primary") === "var(--color-bg-primary)". */
export function cssVar(path: TokenPath): string {
  return `var(--${path.replace(/\./g, "-")})`
}
